module.exports = __webpack_public_path__ + "static/media/UA-Luminary-Retro-Label-7.325834fa.jpg";